import React from 'react';
import { CanonicalResellerNewMerchant } from 'components';

const CanonicalResellerMerchantComponent = (props) => {
    const merchantId = props.location.state?.merchantId;
    return <CanonicalResellerNewMerchant merchantId={merchantId} />;
};

export default CanonicalResellerMerchantComponent;
